module.exports = __webpack_public_path__ + "static/media/wizualizacja-105.076c9f8f.png";